// extracted by mini-css-extract-plugin
module.exports = {"badge":"CornerBadge_badge__1Qk2S","ribbon":"CornerBadge_ribbon__13tmJ"};